import Vue from 'vue'
import RouteTitle from './route-title'

Vue.directive("route-title", RouteTitle)
